import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e0673fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex flex-column w-full mt-3"
}
const _hoisted_2 = { class: "flex flex-column" }
const _hoisted_3 = { class: "relative z-1 border-1 border-300 border-round-2xl p-3" }
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = { class: "flex align-items-center gap-2 text-base" }
const _hoisted_6 = { class: "step-number border-1 border-300 border-round-lg h-2rem w-2rem" }
const _hoisted_7 = {
  key: 0,
  class: "font-semibold"
}
const _hoisted_8 = {
  key: 1,
  class: "font-semibold"
}
const _hoisted_9 = {
  key: 2,
  class: "font-semibold"
}
const _hoisted_10 = {
  key: 3,
  class: "ml-auto text-600"
}
const _hoisted_11 = { class: "font-semibold text-800" }
const _hoisted_12 = { class: "flex justify-content-between gap-4 text-base" }
const _hoisted_13 = { class: "text-primary font-semibold" }
const _hoisted_14 = {
  key: 0,
  class: "flex-shrink-0 text-600"
}
const _hoisted_15 = {
  key: 0,
  class: "step-connector"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-line" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconMapPin = _resolveComponent("IconMapPin")!
  const _component_IconFlag = _resolveComponent("IconFlag")!

  return (_ctx.leg.showSteps || _ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leg.steps, (step, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      (index === 0)
                        ? (_openBlock(), _createBlock(_component_IconMapPin, { key: 0 }))
                        : _createCommentVNode("", true),
                      (index > 0 && index < _ctx.leg.steps.length - 1)
                        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.getIconComponent(step.relativeDirection)), { key: 1 }))
                        : _createCommentVNode("", true),
                      (index === _ctx.leg.steps.length - 1)
                        ? (_openBlock(), _createBlock(_component_IconFlag, { key: 2 }))
                        : _createCommentVNode("", true)
                    ]),
                    (index === 0)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("route_planner.start")), 1))
                      : _createCommentVNode("", true),
                    (index > 0 && index < _ctx.leg.steps.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.getRelativeDirection(step.relativeDirection)), 1))
                      : _createCommentVNode("", true),
                    (index === _ctx.leg.steps.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("route_planner.destination")), 1))
                      : _createCommentVNode("", true),
                    (index > 0 && index !== _ctx.leg.steps.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                          _createTextVNode(_toDisplayString(_ctx.$t("route_planner.absolute_direction")) + " ", 1),
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.getAbsoluteDirection(step.absoluteDirection)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getStreetName(step, index)), 1),
                    (index > 0 && index !== _ctx.leg.steps.length - 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getDistance(step.distance.value)), 1))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              (index !== _ctx.leg.steps.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true)
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}